import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Send } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { Logo } from "./Logo";
import { toast } from "sonner";
import { useState } from "react";

export function Footer() {
  const { t } = useLang();
  const [email, setEmail] = useState("");

  return (
    <footer className="border-t border-border bg-card/40 relative z-10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <Link to="/" className="flex items-center gap-2.5 mb-4">
            <Logo className="h-9" />
          </Link>
          <p className="text-sm text-muted-foreground font-light leading-relaxed max-w-xs">{t("footer.tagline")}</p>
          <div className="flex gap-3 mt-5">
            {[Instagram, Facebook, Twitter].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 grid place-items-center border border-border hover:border-primary hover:text-primary transition-colors duration-300" aria-label="social">
                <Icon size={16} />
              </a>
            ))}
          </div>
          <a
            href="https://www.capecoralhomepro.com" target="_blank" rel="noopener noreferrer"
            className="mt-6 inline-block group/esq" data-testid="esquire-logo-link" aria-label="Esquire Real Estate — CapeCoralHomePro.com"
          >
            <img src="/esquire-realestate.png" alt="Esquire Real Estate" className="h-14 sm:h-16 w-auto object-contain opacity-90 group-hover/esq:opacity-100 transition-opacity duration-300" />
          </a>
        </div>

        <div>
          <h4 className="label-caps text-primary mb-4">{t("footer.explore")}</h4>
          <ul className="space-y-2.5 text-sm font-light text-muted-foreground">
            <li><Link to="/buy" className="hover:text-primary transition-colors">{t("nav.buy")}</Link></li>
            <li><Link to="/rent" className="hover:text-primary transition-colors">{t("nav.rent")}</Link></li>
            <li><Link to="/neighborhoods" className="hover:text-primary transition-colors">{t("nav.neighborhoods")}</Link></li>
            <li><Link to="/journal" className="hover:text-primary transition-colors">{t("nav.journal")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="label-caps text-primary mb-4">{t("footer.company")}</h4>
          <ul className="space-y-2.5 text-sm font-light text-muted-foreground">
            <li><Link to="/agents" className="hover:text-primary transition-colors">{t("nav.agents")}</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors">{t("nav.contact")}</Link></li>
            <li><a href="#" className="hover:text-primary transition-colors">{t("footer.about")}</a></li>
            <li><a href="#" className="hover:text-primary transition-colors">{t("footer.careers")}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="label-caps text-primary mb-4">{t("footer.newsletter")}</h4>
          <form
            onSubmit={(e) => { e.preventDefault(); toast.success("Subscribed!"); setEmail(""); }}
            className="flex border border-border focus-within:border-primary transition-colors"
          >
            <input
              value={email} onChange={(e) => setEmail(e.target.value)} required type="email"
              placeholder={t("footer.newsletter")}
              className="flex-1 bg-transparent px-3 py-3 text-sm outline-none"
              data-testid="newsletter-input"
            />
            <button className="px-4 bg-primary text-primary-foreground" data-testid="newsletter-submit"><Send size={16} /></button>
          </form>
        </div>
      </div>
      <a
        href="https://www.210codelabs.com" target="_blank" rel="noopener noreferrer"
        className="block border-t border-border py-7 group"
        data-testid="codelabs-logo-link" aria-label="Developed by 210 CODELABS"
      >
        <img src="/210codelabs.png" alt="Developed by 210 CODELABS" className="mx-auto h-11 sm:h-14 w-auto max-w-[90%] object-contain opacity-85 group-hover:opacity-100 transition-opacity duration-300" />
      </a>
      <div className="border-t border-border">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted-foreground font-light">
          <p>© 2026 {t("brand")}. {t("footer.rights")} · <a href="https://www.210codelabs.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-testid="developed-by-link">Developed by 210 CODELABS</a></p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-primary transition-colors">{t("footer.privacy")}</a>
            <a href="#" className="hover:text-primary transition-colors">{t("footer.terms")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
